import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { toast } from 'react-toastify';
import { FiMail, FiPhone, FiMapPin, FiSend } from 'react-icons/fi';
import { FaInstagram, FaTiktok, FaWhatsapp } from 'react-icons/fa';
import { trackContact } from '../utils/metaPixel';
import './ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1500));

    trackContact({ content_name: 'contact_form' });
    toast.success('ההודעה נשלחה בהצלחה! ניצור איתך קשר בהקדם.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
    setIsSubmitting(false);
  };

  const contactInfo = [
    {
      icon: FiMail,
      title: 'אימייל',
      value: 'admin@aiweon.co.il',
      link: 'mailto:admin@aiweon.co.il'
    },
    {
      icon: FiPhone,
      title: 'טלפון',
      value: '052-2398911',
      link: 'tel:0522398911'
    },
    {
      icon: FiMapPin,
      title: 'כתובת',
      value: 'דרך חיפה 19, ק.אתא',
      link: null
    }
  ];

  const socialLinks = [
    { icon: FaInstagram, label: 'Instagram', href: 'https://www.instagram.com/aiweon_' },
    { icon: FaTiktok, label: 'TikTok', href: 'https://www.tiktok.com/@aiweon?_r=1&_t=ZS-92iCRpdDXsL' },
    { icon: FaWhatsapp, label: 'WhatsApp', href: 'https://wa.me/972522398911?text=%D7%A0%D7%A9%D7%9E%D7%97%20%D7%9C%D7%A7%D7%91%D7%9C%20%D7%A4%D7%A8%D7%98%D7%99%D7%9D%20%D7%A0%D7%95%D7%A1%D7%A4%D7%99%D7%9D%20%D7%A2%D7%9C%20%D7%90%D7%A4%D7%A9%D7%A8%D7%95%D7%AA%20%D7%9C%D7%A9%D7%99%D7%AA%D7%95%D7%A3%20%D7%A4%D7%A2%D7%95%D7%9C%D7%94%20%D7%91%D7%AA%D7%97%D7%95%D7%9D%20%D7%94%D7%9E%D7%A9%D7%A4%D7%99%D7%A2%D7%A0%D7%99%D7%9D.' }
  ];

  return (
    <div className="contact-page">
      {/* Header */}
      <section className="contact-header" style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url(${process.env.PUBLIC_URL}/contact-hero.png)` }}>
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1>צור קשר</h1>
            <p>נשמח לשמוע ממך! מלא את הפרטים ונחזור אליך בהקדם</p>
          </motion.div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content section">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Form */}
            <motion.div
              className="contact-form-card"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
            >
              <h2>שלח לנו הודעה</h2>
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">שם מלא *</label>
                    <input
                      type="text"
                      name="name"
                      className="form-input"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">טלפון</label>
                    <input
                      type="tel"
                      name="phone"
                      className="form-input"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">אימייל *</label>
                  <input
                    type="email"
                    name="email"
                    className="form-input"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">נושא</label>
                  <select
                    name="subject"
                    className="form-select"
                    value={formData.subject}
                    onChange={handleChange}
                  >
                    <option value="">בחר נושא...</option>
                    <option value="creator">הרשמה כיוצר תוכן</option>
                    <option value="brand">הרשמה כמותג</option>
                    <option value="campaign">שאלה על קמפיין</option>
                    <option value="support">תמיכה טכנית</option>
                    <option value="other">אחר</option>
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label">הודעה *</label>
                  <textarea
                    name="message"
                    className="form-textarea"
                    value={formData.message}
                    onChange={handleChange}
                    rows={5}
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary btn-lg"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    'שולח...'
                  ) : (
                    <>
                      <FiSend />
                      שלח הודעה
                    </>
                  )}
                </button>
              </form>
            </motion.div>

            {/* Contact Info */}
            <motion.div
              className="contact-info"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
            >
              <div className="info-card">
                <h2>פרטי התקשרות</h2>
                <div className="info-list">
                  {contactInfo.map((info, index) => (
                    <div key={index} className="info-item">
                      <div className="info-icon">
                        <info.icon />
                      </div>
                      <div className="info-content">
                        <span className="info-title">{info.title}</span>
                        {info.link ? (
                          <a href={info.link} className="info-value">{info.value}</a>
                        ) : (
                          <span className="info-value">{info.value}</span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="social-card">
                <h3>עקבו אחרינו</h3>
                <div className="social-links">
                  {socialLinks.map((social, index) => (
                    <a
                      key={index}
                      href={social.href}
                      className="social-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.label}
                    >
                      <social.icon />
                    </a>
                  ))}
                </div>
              </div>

            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
